var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M.802 13.602l4.895-4.895c.035-.035.067-.073.097-.112L7.4 9.8a1 1 0 0 0 1.2 0l1.61-1.207c.031.045.068.089.108.13l4.88 4.879c-.334.25-.749.398-1.198.398H2c-.45 0-.864-.148-1.198-.398zM0 11.576V4.25l4.186 3.14L0 11.576zm16 0L11.814 7.39 16 4.25v7.326zm-.834-9.2L8 7.75.834 2.375A1.99 1.99 0 0 1 2 2h12c.435 0 .838.14 1.166.375z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2a63ca2d94020d05de3db2327b63df5c.svg";
export { ForwardRef as ReactComponent };